import React, { useEffect, useState } from "react";
import axios from "axios";
import configData from "../config.json";
import { useParams } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {ProductionAnalysis, SalesAnalysis, ProfitLossAnalysis} from '../components';


const Misreport = () => {
  const { branchID, fYear } = useParams();

  const [misData, setMisData] = useState([]);
  const [branchName, setBranchName] = useState("");

  // =========================
  // FORMAT FUNCTIONS
  // =========================
  const format = (value) => {
    if (value === null || value === undefined || isNaN(value)) {
      return "0.00";
    }

    return Number(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const growthPercent = (current, previous) => {
    if (!previous || previous === 0) return 0;

    return (((current - previous) / previous) * 100).toFixed(2);
  };

  const achievementPercent = (actual, target) => {
    if (!target || target === 0) return 0;

    return ((actual / target) * 100).toFixed(2);
  };

  // =========================
  // LOAD DATA
  // =========================
  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(`${configData.SERVER_URL}/misReport/${branchID}/${fYear}` );

        setMisData(response.data.data || []);

        if (
          response.data.localBranch &&
          response.data.localBranch.length > 0
        ) {
          setBranchName(response.data.localBranch[0].branchName);
        }
      } catch (error) {
        console.error("Production Analysis Error:", error);
      }
    };

    getData();
  }, [branchID, fYear]);

  // =========================
  // SUMMARY
  // =========================
  const totalTarget = misData.reduce(
    (a, b) => a + Number(b.proMtQty || 0),
    0
  );

  const totalProduction = misData.reduce(
    (a, b) => a + Number(b.proQty || 0),
    0
  );

  const totalPreviousProduction = misData.reduce(
    (a, b) => a + Number(b.preProQty || 0),
    0
  );

  const totalGrowth = growthPercent(
    totalProduction,
    totalPreviousProduction
  );

  return (
    <div className="container-fluid">

      {/* =========================================
                  PAGE HEADER
      ========================================= */}
      <div className="row mb-3">
        <div className="col-md-12">
          <div className="card shadow">
            <div className="card-body bg-success text-white">
              <h3>
                Analysis Report
              </h3>

              <h5>
                {branchName}
              </h5>

              <p>
                Financial Year : {fYear}-{Number(fYear) + 1}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* =========================================
                  KPI CARDS
      ========================================= */}
      {/* <div className="row mb-4">

        <div className="col-md-3 mb-3">
          <div className="card shadow border-0 bg-primary text-white">
            <div className="card-body">
              <h6>Total Target</h6>
              <h3>{format(totalTarget)}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="card shadow border-0 bg-success text-white">
            <div className="card-body">
              <h6>Current Production</h6>
              <h3>{format(totalProduction)}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="card shadow border-0 bg-warning">
            <div className="card-body">
              <h6>Previous Production</h6>
              <h3>{format(totalPreviousProduction)}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div
            className={`card shadow border-0 ${
              totalGrowth >= 0
                ? "bg-info text-white"
                : "bg-danger text-white"
            }`}
          >
            <div className="card-body">
              <h6>Growth %</h6>

              <h3>
                {totalGrowth} %

                {totalGrowth >= 0 ? (
                  <Icon.ArrowUpCircleFill
                    className="ms-2"
                  />
                ) : (
                  <Icon.ArrowDownCircleFill
                    className="ms-2"
                  />
                )}
              </h3>
            </div>
          </div>
        </div>
      </div> */}

      {/* =========================================
                  TABLE SECTION
      ========================================= */}
      <ProductionAnalysis
      misData={misData}
      branchName={branchName}
      fYear={fYear}
      />
      
      <SalesAnalysis
      misData={misData}
      branchName={branchName}
      fYear={fYear}
      />

      <ProfitLossAnalysis
      misData={misData}
      branchName={branchName}
      fYear={fYear}
      />
    </div>
  );
};

export default Misreport;